import api from '../api'

export default {
  
  users: async (page, take, sortBy, sortOrder, search,filters) => {
    return api.get(`api/logs/users?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  get: async (id,page, take, sortBy, sortOrder, search,filters) => {
    return api.get('api/logs/user/' + id+`?page=${page}&take=${take}&sort_by=${sortBy}&sort_order=${sortOrder}&search=${search}&filters=${filters}`)
  },

  details: async (id,logId) => {
    return api.get('api/logs/user/'+id+'/show/'+logId)
  },

}
